import bgImage from "assets/img/imagem_cordilheira.svg";
import nuvens from "assets/img/nuvens.svg";

const styles = {

  Splashscreen: {
    "width": "100%",
    "minHeight": "100%",
    "overflow": "hidden",
    "padding": "50px 0",
    backgroundSize: "auto 65%, contain",
    backgroundPosition: "bottom -100px right 100px, 0",
    backgroundRepeat: "no-repeat",
    backgroundImage: "url(" + bgImage + "), linear-gradient(0deg, rgba(140,207,230,1) 0%, rgba(217,238,245,1) 100%)",
    "& .logo": {
      "backgroundSize": "contain",
      "height": "70vh",
      "width": "85%",
      "maxWidth": "750px",
      "margin": "auto",
      "backgroundPosition": "center",
      "backgroundRepeat": "no-repeat",
      "transition": "all 1s",
      "-webkitAnimationName": "pulse",
      "animationName": "pulse",
      "-webkitAnimationDuration": "6s",
      "animationDuration": "6s",
      "-webkitAnimationFillMode": "both",
      "animationFillMode": "both",
      "-webkitAnimationIterationCount": "infinite",
      "animationIterationCount": "infinite",
      "-webkitAnimationTimingFunction": "cubic-bezier(0.45, 0.05, 0.55, 0.95)",
      "animationTimingFunction": "cubic-bezier(0.45, 0.05, 0.55, 0.95)",
    },
    "& .withBox .logo": {
      "height": "160px",
    },
    "& .splashBox": {
      "maxWidth": "600px",
      "margin": "auto",
      "marginTop": "50px",
    },

    "& .loadingTextContainer": {
      "position": "relative",
      "textAlign": "center",
    },
    "& .loadingTextContainer h3": {
      "color": "#11111",
    },
    "& .loadingTextContainer > .progress": {
      "position": "absolute",
      "top": "-55px",
      "marginLeft": "-75px",
    },
    "&:before": {
      display: "block",
      content: '""',
      position: "absolute",
      width: "100%",
      height: "100%",
      top: "0",
      left: "0",
      "-webkit-animation": "slide-vertical 6s ease-in-out infinite alternate both",
      animation: "slide-vertical 6s ease-in-out infinite alternate both",
      backgroundSize: "100% auto",
      backgroundPosition: "top",
      backgroundRepeat: "no-repeat",
      backgroundImage: "url(" + nuvens + ")",
    }
  },

  splashBackground: {
    "backgroundSize": "cover",
    "backgroundPosition": "center",
    "filter": "brightness(50%)",
    "height": "100%",
    "width": "100%",
    "position": "absolute"
  }
};

export default styles;